import React from 'react';
import { Button, Form, Header, Segment, Input, Select } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CreateCourseImplementation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semester: '',
            semesters: [],
            academicYears: [],
            academicYear: '',
            courseRoleTypes: [],
            professors: [],
            assistants: [],
            professorsList: [],
            leadStaff: [],
            assistantsList: [],
            staff: [],
            courseImplementationId: '',

            semesterErr: false,

            disabledButton: false
        };

        this.createImplementation = this.createImplementation.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.addStaff = this.addStaff.bind(this);
    }

    componentDidMount() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                let academicYears = res.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYears
                });
            })
            .catch(err => {
                console.log('Failed to fetch academic years.');
            });

        axios.get('course-role-types')
            .then(res => {
                this.setState({ courseRoleTypes: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch course role types.');
            });


        let obj = {};
        axios.post(`employees/by-key/professor/${localStorage.getItem('orgUnitId')}`, { ...obj })
            .then(res => {
                const professors = res.data.map(el => ({
                    ...el, key: el.id, value: { value: el.id, key: el.id, text: el.firstName + ' ' + el.lastName }, text: el.firstName + ' ' + el.lastName
                }));
                this.setState({ professors });
            })
            .catch(err => {
                console.log('Failed to fetch professors');
            });

        axios.post(`employees/by-key/assistant/${localStorage.getItem('orgUnitId')}`, { ...obj })
            .then(res => {
                const assistants = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.firstName + ' ' + el.lastName
                }));
                this.setState({ assistants });
            })
            .catch(err => {
                console.log('Failed to fetch assistants');
            });
    }

    createImplementation(semester) {
        let courseImplObj = {
            semester
        };

        courseImplObj = {
            semesterId: semester,
            courseBasicId: localStorage.getItem('courseBasicId')
        };

        if (!semester) {
            if (!semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            toast('Niste unijeli sva obavezna polja!');
        } else {
            axios.post(`course/add-implementation/${localStorage.getItem('orgUnitId')}`, { ...courseImplObj })
                .then(res => {
                    if (this.state.professorsList.length || this.state.assistantsList.length || this.state.leadStaff) {
                        this.addStaff(this.state.professorsList, this.state.assistantsList, this.state.leadStaff, res.data.id);
                    }
                    this.setState({
                        semester: null, academicYear: null, professorsList: [], assistantsList: [], leadStaff: [], disabledButton: false
                    });
                })
                .catch(err => {
                    if (err.response.data === 'This course implementation is already created!') {
                        toast('Implementacija predmeta u odabranom semestru je već kreirana!');
                    } else {
                        toast('Došlo je do greške! Kreiranje implementacije predmeta nije uspjelo.');
                    }
                });
        }
    }

    addStaff(professorsList, assistantsList, leadStaff, courseImplementationId) {
        let staffList = [];

        if (professorsList) {
            professorsList.map(el => (
                staffList.push({
                    courseImplementation: { id: courseImplementationId },
                    leadStaff: !!leadStaff.find(e => e === el.value),
                    employee: { id: el.value },
                    courseRoleType: { id: this.state.courseRoleTypes.find(e => e.name === 'profesor').id }
                })
            ));
        }

        if (assistantsList) {
            assistantsList.map(el => (
                staffList.push({
                    courseImplementation: { id: courseImplementationId },
                    leadStaff: false,
                    employee: { id: el },
                    courseRoleType: { id: this.state.courseRoleTypes.find(e => e.name === 'asistent').id }
                })
            ));
        }


        axios.post('course/implementation/staff/', [...staffList])
            .then(res => {
                toast('Uspješno ste kreirali implementaciju i dodali osoblje na predmet.');
            })
            .catch(err => {
                toast('Došlo je do greške! Dodavanje osoblja na predmet nije uspjelo.');
            });
    }

    getSemesters(id) {
        axios.get(`semester/by-academic-year/${id}`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        ...el, key: el.name._key, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYear') {
            this.getSemesters(value);
        }
        this.setState({
            [name]: value
        });
    }


    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije</Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {localStorage.getItem('courseBasicName')}
                            {/*{localStorage.getItem('comment') ? ' / ' + localStorage.getItem('comment') : ''}*/}
                            <Header.Subheader>
                                {(localStorage.getItem('comment'))==='null' ? '' : localStorage.getItem('comment')}
                                {/*Predmet {localStorage.getItem('comment') ? ' / napomena' : ''}*/}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Select}
                                    label="Akademska godina"
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYear}
                                    name="academicYear"
                                    options={this.state.academicYears}
                                    onChange={this.handleInputChange}
                                />
                                <Form.Field
                                    required
                                    control={Select}
                                    label="Semestar"
                                    placeholder="Odaberite semester"
                                    value={this.state.semester}
                                    name="semester"
                                    options={this.state.semesters.filter(e => e.key !== 'other')}
                                    onChange={this.handleInputChange}
                                    error={this.state.semesterErr}
                                />
                            </Form.Group>


                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Profesori</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite profesora/e"
                                        value={this.state.professorsList}
                                        onChange={this.handleInputChange}
                                        name="professorsList"
                                        options={this.state.professors}
                                        search
                                        fluid
                                        selection
                                        multiple
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Nosilac / nosioci predmeta</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite profesora/e"
                                        value={this.state.leadStaff}
                                        onChange={this.handleInputChange}
                                        name="leadStaff"
                                        options={this.state.professorsList}
                                        search
                                        fluid
                                        selection
                                        multiple
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Asistenti</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite asistenta"
                                        value={this.state.assistantsList}
                                        onChange={this.handleInputChange}
                                        name="assistantsList"
                                        options={this.state.assistants}
                                        search
                                        fluid
                                        selection
                                        multiple
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>

                            <Button basic="true" color="blue" onClick={() => window.history.go(-1)} floated="right">Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                disabled={this.state.disabledButton}
                                onClick={
                                    () => {
                                        this.setState({ disabledButton: true }, () => {
                                        this.createImplementation(
                                            this.state.semester,
                                            this.state.academicYear
                                        );
                                        });
                                    }
                                }
                            >
                                Kreiraj implementaciju
                            </Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/CreateCourseImplementation.js